import { type AxiosInstance } from "axios";
import type {
  BulkResolveRequest,
  BulkResolveResponse,
} from "@/features/propertyCodeBulkAcquisition/types";

// 照合 API の呼び出し層。HTTP 呼び出しをここに集約する

/** 照合エンドポイント。POST /api/property-codes/resolve（baseURL が /api を付与）。 */
export const BULK_RESOLVE_ENDPOINT = "/property-codes/resolve";

/**
 * 物件コード群をマッチングテーブルで一括解決する fetcher。
 * エラーは throw し、HTTP ステータスによる判定は呼び出し側で行う。
 * @param apiClient JWT 認証付き apiClient
 * @param request 所有者グループごとの物件コード群
 */
export const postBulkResolve = async (
  apiClient: AxiosInstance,
  request: BulkResolveRequest
): Promise<BulkResolveResponse> => {
  const { data } = await apiClient.post<BulkResolveResponse>(
    BULK_RESOLVE_ENDPOINT,
    request
  );
  return data;
};
